<template>
  <div>
    <div v-if="!showimg" class="vimg" :style="style()">
      <img :style="{height: height1}" mode="heightFix" src="@/assets/image/timesignin/39.png">
      </img>
    </div>
    <img @mousemove.stop="" @click="imgPre" v-show="showimg" class="s-img" @load="showimg = true" :style="style()" :mode="mode" :src="src">
    </img>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  name: 'UniMailiangSImage',

  props: {
    src: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'widthFix'
    },
    borderRadius: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    height1: {
      type: String,
      default: '33%'
    },
    openImg:{
      type: Object,
      default: null
    }
  },

  data() {
    return {
      showimg: false
    };
  },

  mounted() {

  },

  methods: {
    style() {
      const styles = {
        borderRadius: this.borderRadius,
        width: this.width,
        height: this.height
      };
      if(!this.showimg) return styles;
      switch (this.mode) {
        case 'scaleToFill':
          styles.objectFit = 'fill';
          break;
        case 'aspectFit':
          styles.objectFit = 'contain';
          break;
        case 'aspectFill':
          styles.objectFit = 'cover';
          break;
        case 'widthFix':
        case 'heightFix':
          styles.objectFit = 'contain';
          if (this.mode === 'widthFix') {
            styles.height = 'auto';
          } else {
            styles.width = 'auto';
          }
          break;
        case 'top':
          styles.objectFit = 'cover';
          styles.objectPosition = 'top';
          break;
        case 'bottom':
          styles.objectFit = 'cover';
          styles.objectPosition = 'bottom';
          break;
        case 'center':
          styles.objectFit = 'cover';
          styles.objectPosition = 'center';
          break;
        case 'left':
          styles.objectFit = 'cover';
          styles.objectPosition = 'left';
          break;
        case 'right':
          styles.objectFit = 'cover';
          styles.objectPosition = 'right';
          break;
        case 'top left':
          styles.objectFit = 'cover';
          styles.objectPosition = 'top left';
          break;
        case 'top right':
          styles.objectFit = 'cover';
          styles.objectPosition = 'top right';
          break;
        case 'bottom left':
          styles.objectFit = 'cover';
          styles.objectPosition = 'bottom left';
          break;
        case 'bottom right':
          styles.objectFit = 'cover';
          styles.objectPosition = 'bottom right';
          break;
      }
      
      return styles;
    },
    imgPre() {
      if(this.openImg){
        ImagePreview({
          startPosition: this.openImg.i,
          images: this.openImg.imgs,
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vimg {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #e1e1e1;
  border-radius: 10px;
  img {
    height: 33%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
  }
}
.s-img {
  width: 100%;
  height: 100%;
  // transition: all 0.1s;
  object-fit: cover;
  display: block;
}
</style>